export default __webpack_public_path__ + "2cd4a3d94d3439cbcb9ddb3144b73400.svg";